import styles from "./LoginPage.module.scss";

const LoginFooter = ({ isPWA, onPasswordReset }) => {
  if (isPWA) {
    return (
      <div className={styles.moreInfo}>
        <div className={styles.subscribeText}>
          To subscribe please visit{" "}
          <a
            href="https://app.tg.org.au"
            target="_blank"
            rel="noopener noreferrer"
          >
            app.tg.org.au
          </a>
        </div>
        <button onClick={onPasswordReset} className={styles.forgotPassword}>
          Forgot your password?
        </button>
      </div>
    );
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footerRow}>
        <a href="https://tg.org.au/conditions-of-use-and-disclaimer">
          Conditions of Use
        </a>
        <a href="https://tg.org.au/license-agreement">Licence Agreement</a>
        <a href="https://tg.org.au/privacy-policy">Privacy Policy</a>
      </div>
      <div className={styles.footerRow}>
        <a href="https://www.tg.org.au/about-us/resources/">Resource Hub</a>
        <a href="https://tg.org.au/faq">Support and FAQ</a>
      </div>
    </footer>
  );
};

export default LoginFooter;
